import React from 'react';
import { Button } from 'shards-react';
import { useTranslation } from 'react-i18next';

interface EditConditionOrdinaryProps {
  editable: boolean;
  onClick: () => void;
}

const EditConditionOrdinary = ({ editable, onClick }: EditConditionOrdinaryProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <Button className="mr-2" size="sm" disabled={!editable} onClick={onClick}>
        {t('condition.add')}
      </Button>
    </>
  );
};

export default EditConditionOrdinary;
